import { convertToMajorUnit } from '@/helpers/money'
import useTransactionDataStore from '@/stores/transactionData'
import type { SummaryData, Maybe } from '@/types'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
// @ts-ignore
import { useStore } from 'vuex'

export const useSummaryDataStore = defineStore(
  'summaryData',
  () => {
    const vuexStore = useStore()

    const transactionDataStore = useTransactionDataStore()

    const summaryData = ref<Maybe<SummaryData>>()

    const getSummaryData = computed<Maybe<SummaryData>>(() => summaryData.value)

    function saveSummaryData(payload: Partial<SummaryData> & Pick<SummaryData, 'sessionId'>): void {
      const selectedOrotherAmount = transactionDataStore.getSelectedOrOtherAmount
      summaryData.value = {
        type: transactionDataStore.paymentType,
        amount: selectedOrotherAmount ? convertToMajorUnit(selectedOrotherAmount) : 0,
        fundraisingPayment: vuexStore.getters['child/getPaidAmount'],
        childEditionId: vuexStore.getters['child/getChild']?.id,
        childEditionRetentionHash: vuexStore.getters['child/getChildEditionRetentionHash'],
        ...payload
      }
    }

    function reset(): void {
      summaryData.value = null
    }

    return {
      summaryData,
      getSummaryData,
      saveSummaryData,
      reset
    }
  },
  {
    persist: true
  }
)
